var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import apis from 'app/apis/index';
import store from 'app/configureStore';
export var beginLogin = function () { return function (dispatch) {
    dispatch({
        type: 'USER_LOGGING_IN',
    });
}; };
export var beginUpdateUser = function (user) { return function (dispatch) {
    dispatch({
        type: 'BEGIN_UPDATE_USER'
    });
    updateUser(user, dispatch);
}; };
var updateUser = function (userParam, dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var user, storeData, accessToken, dbUser, _a, err, response;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                user = userParam;
                storeData = store.getState();
                accessToken = storeData.user.accessToken;
                dbUser = __assign(__assign({}, user), user.user_metadata);
                return [4 /*yield*/, apis.user.sandboxDbUser.update(dbUser, accessToken)];
            case 1:
                _a = _b.sent(), err = _a[0], response = _a[1];
                dispatch({
                    type: err ? 'UPDATE_USER_FAILED' : 'UPDATE_USER_SUCCESS',
                    user: user,
                });
                return [2 /*return*/];
        }
    });
}); };
export var handleLogin = function (result) { return function (dispatch) {
    dispatch({
        type: 'USER_LOGIN_SUCCESS',
        user: result,
    });
}; };
var updateUserAppMeta = function (params, dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var storeData, accessToken, _a, error, result;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                storeData = store.getState();
                accessToken = storeData.user.accessToken;
                return [4 /*yield*/, apis.user.sandboxDbUser.update(params, accessToken)];
            case 1:
                _a = _b.sent(), error = _a[0], result = _a[1];
                dispatch({
                    type: error ? 'USER_META_UPDATE_FAILED' : 'USER_META_UPDATE_SUCCESS',
                    user: {
                        user_metadata: result.data,
                        app_metadata: result.data
                    },
                });
                return [2 /*return*/];
        }
    });
}); };
export var beginUserAppMetaUpdate = function (params) { return function (dispatch) {
    dispatch({
        type: 'USER_META_UPDATE',
    });
    updateUserAppMeta(params, dispatch);
}; };
export var logout = function () { return function (dispatch) {
    dispatch({
        type: 'USER_LOGOUT',
    });
}; };
export var dispatchUpdateUserMeta = function (_a) {
    var key = _a.key, value = _a.value, userId = _a.userId;
    // @ts-ignore
    store.dispatch(beginUserAppMetaUpdate({ key: key, value: value, user_id: userId }));
};
export var dispatchUpdateUser = function (user) {
    // @ts-ignore
    store.dispatch(beginUpdateUser(user));
};
export var dispatchUserUpdate = function (user) {
    // @ts-ignore
    store.dispatch(updateUser(user, {}));
};
